import { ICellRendererParams } from 'ag-grid-community';
import { Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Order } from '@compumark/order-management-client';

import { environment } from '../../../environments/environment';
import {
  ExpandedImageComponent,
  ImageData,
} from '../../expended-image/expanded-image.component';

@Component({
  selector: 'app-logo-renderer',
  templateUrl: './logo-renderer.component.html',
  styleUrls: ['./logo-renderer.component.scss'],
  standalone: false,
})
export class LogoRendererComponent {
  dialog = inject(MatDialog);

  public isVisible = true;
  public imageUrl!: string;

  private order!: Order;

  agInit(params: ICellRendererParams): void {
    if (params.column?.getColId() === 'logo') {
      if (params.data.orderNumber) {
        this.imageUrl = `${environment.backendBaseUrl}/orders/image/${params.data.orderNumber}`;
      }
    }
    this.order = params.data;
  }

  public openLogo(): void {
    const data = {
      imageUrl: this.imageUrl,
      title: this.order.trademarkName,
      titlePrefix: 'Logo',
    } as ImageData;
    this.dialog
      .open(ExpandedImageComponent, {
        autoFocus: false,
        data,
        width: '50%',
      })
      .afterClosed()
      .subscribe();
  }
}
